var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0001 23.2588L17.501 9.40643H8.49902L13 23.2588H13.0001Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 23.2587L8.49901 9.40631H2.19116L13 23.2587Z",
    fill: "#FC6D26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.19116 9.40631L0.823418 13.616C0.762604 13.8032 0.762596 14.0047 0.823394 14.1919C0.884193 14.379 1.00268 14.5421 1.16187 14.6578L13 23.2588L2.19107 9.40641L2.19116 9.40631Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.19116 9.40639H8.49901L5.78826 1.06317C5.64875 0.633845 5.04142 0.633941 4.90201 1.06317L2.19116 9.40639Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13 23.2587L17.501 9.40631H23.8089L12.9999 23.2587H13Z",
    fill: "#FC6D26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.8089 9.40631L25.1767 13.616C25.2375 13.8032 25.2375 14.0048 25.1766 14.1919C25.1158 14.3791 24.9973 14.5422 24.8381 14.6578L13.0001 23.2588L23.8089 9.40641V9.40631Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.8089 9.40639H17.501L20.2118 1.06317C20.3513 0.633845 20.9587 0.633941 21.0981 1.06317L23.8089 9.40639Z",
    fill: "#E24329"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.38bb3d7fec4d56ef21115b90e4fc8fd7.svg";
export { ForwardRef as ReactComponent };